import React, { Component } from "react";
import ReactDOM from "react-dom";

import bgDesktop from "../../assets/images/Pantalla_Inicial/fondo_horizontal";
import bgMobile from "../../assets/images/Pantalla_Inicial/fondo_vertical";
import primero_lee from "../../assets/images/Pantalla_Inicial/primero_lee_logo";
import nave from "../../assets/images/Pantalla_Inicial/nave";
import viaje_letras from "../../assets/images/Pantalla_Inicial/logo_juego_letra_M";
import iniciar_button from "../../assets/images/Pantalla_Inicial/boton_iniciar";
import iniciar_button2 from "../../assets/images/Pantalla_Inicial/boton_iniciar_presionado";
import click from "../../assets/sound/fx/click.mp3";
import Instrucciones from "../../assets/sound/narracion/instrucciones.mp3";
import "./App.css";

import Instructivo from "./Instructivo";

export default class Inicio extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      hover: false,
    };
    this.setButton = this.setButton.bind(this);
  }

  componentDidMount() {}

  Iniciar() {
    // ReactGA.event({
    //   category: "leB",
    //   action: "FfleB",
    // });

    let audio = new Audio(click);
    audio.play();
    let instrucciones = new Audio(Instrucciones);
    instrucciones.play();
    instrucciones.pause();

    setTimeout(function () {
      // let newValor = value;
      const element = <Instructivo instrucciones={instrucciones} />;
      ReactDOM.render(element, document.getElementById("root"));
    }, 1500);
  }

  setButton() {
    let hover = !this.state.hover;
    this.setState({ hover });
    console.log(hover);
  }

  render() {
    return (
      <div
        style={{
          backgroundColor: "#247BA0",
          position: "relative",
          textAlign: "center",
          width: "100%",
          height: "100%",
        }}
      >
        {(window.innerWidth > 480) &
        (window.innerWidth / window.innerHeight > 1) ? (
          <div>
            <img
              src={bgDesktop}
              className="final-background-image"
              alt="background"
            />{" "}
          </div>
        ) : (
          <div>
            <img
              src={bgMobile}
              className="final-background-image"
              alt="background"
            />{" "}
          </div>
        )}
        <div>
          <img src={primero_lee} className="primero_lee" alt="primero lee" />
        </div>
        <div>
          <img src={nave} className="nave" alt="Nave" />
        </div>
        <div>
          <img
            src={viaje_letras}
            className="letras_viaje"
            alt="Viaje por las letras"
          />
        </div>
        <div
          onMouseDown={() => this.setState({ hover: true })}
          onMouseUp={this.Iniciar}
        >
          {!this.state.hover ? (
            <img src={iniciar_button} className="boton_iniciar" alt="Iniciar" />
          ) : (
            <img
              src={iniciar_button2}
              className="boton_iniciar"
              alt="Iniciar"
            />
          )}
        </div>
      </div>
    );
  }
}
